import React, { useState, useEffect } from "react";
import axios from "axios";
import Pending from "../../../assets/Icon/rightSign.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const QnaCompleted = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/qna_completed`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="QnA Complete Events"
        image={Pending}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <>
          <AllModuleData
            data={event_data}
            urlLink={`/superstar-admin/qna/details`}
            qna={"true"}
          />
        </>
      )}
    </>
  );
};

export default QnaCompleted;
